import { render, staticRenderFns } from "./fornecedor.vue?vue&type=template&id=e00019d6&"
import script from "./fornecedor.vue?vue&type=script&lang=js&"
export * from "./fornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e00019d6')) {
      api.createRecord('e00019d6', component.options)
    } else {
      api.reload('e00019d6', component.options)
    }
    module.hot.accept("./fornecedor.vue?vue&type=template&id=e00019d6&", function () {
      api.rerender('e00019d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/fornecedor.vue"
export default component.exports